import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrlV1 } from "../../../config/config";
import { agent } from "../../../api";
import { FortuneWheelProfile, WheelProfileUpdate } from "../../../entities/wheelGame_v2";
import { addNotification } from "../../Notification/notificateStore";
import { PiggyProfileGlobalSettings } from "../../../entities/piggyGame";
import { handlerNeedUpdate } from "../fortuneWheelTableStore";

export const getWheelProfile = createAsyncThunk(
  'fotune-wheel/get-profile-by-id',
  async (param: { id: number }): Promise<FortuneWheelProfile> => {
    try {
      const response = await agent.get(`${apiUrlV1}/v3/organization/game/profile/read/${param.id}`)
      if (response.ok) {
        const data = await response.json() as FortuneWheelProfile;
        return data;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)


export const postWheelProfile = createAsyncThunk(
  'fotune-wheel/post-profile-by-id',
  async (param: { data: PiggyProfileGlobalSettings }, thunksApi): Promise<FortuneWheelProfile> => {
    try {
      const v3ProfileBody = {
        ...param.data,
        isSortMode: false,
        isMultiGame: false,
        game: 'fortuneWheel'
      }
      const response = await agent.post(`${apiUrlV1}/v3/organization/game/profile/create/from-global-settings`, {
        body: JSON.stringify(v3ProfileBody)
      })
      if (response.ok) {
        const data = await response.json() as FortuneWheelProfile;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'profile', value: true }));
        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const patchWheelProfile = createAsyncThunk(
  'fotune-wheel/patch-profile-by-id',
  async (param: { data: WheelProfileUpdate, id: number }, thunksApi): Promise<FortuneWheelProfile> => {
    try {
      const response = await agent.patch(`${apiUrlV1}/v3/organization/game/profile/update/from-config-part/${param.id}`, {
        body: JSON.stringify(param.data)
      })
      if (response.ok) {
        const data = await response.json() as FortuneWheelProfile;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'profile', value: true }));

        return data;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string[] | string };
        if (typeof (data.message) === 'object' && data.message.length > 0) {
          data.message.forEach(element => {
            thunksApi.dispatch(
              addNotification({ status: "error", text: element })
            );
          });
        }
        if (typeof (data.message) === 'string') {
          thunksApi.dispatch(
            addNotification({ status: "error", text: data.message })
          );
        }
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)